"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const focusNextElementHandler_1 = __importDefault(require("./focusNextElementHandler"));
const keyboardEvents_1 = require("../../functions/keyboardEvents");
/**
 * A hook that uses arrow key logic to compute the index of a highlighted element within a list
 * @param { number } elementCount The total number of elements from the list
 * @param { number } initialHighlightedElementIndex index of the initial highlighted element.
 * initialHighlightedElementIndex = -1 means there is no initial highlighted element.
 * @returns { number } The index of the element that should be highlighted
 */
const useArrowKeyListIndex = ({ elementCount, windowContext, initialHighlightedElementIndex = 0, }) => {
    const [focusedId, setFocusedId] = (0, react_1.useState)(initialHighlightedElementIndex);
    const handleElementCountChanged = () => {
        // Case when elemnet count is smaller than the current focused index -> update focus index to the last element
        if (focusedId >= elementCount) {
            setFocusedId(elementCount - 1);
        }
    };
    const handleArrow = (0, react_1.useCallback)((event) => {
        if ((0, keyboardEvents_1.isArrowDownEvent)(event)) {
            (0, focusNextElementHandler_1.default)(true, elementCount, setFocusedId);
            return;
        }
        if ((0, keyboardEvents_1.isArrowUpEvent)(event)) {
            (0, focusNextElementHandler_1.default)(false, elementCount, setFocusedId);
        }
    }, [elementCount]);
    (0, react_1.useEffect)(() => {
        (windowContext || window).document.addEventListener('keydown', handleArrow);
        return () => {
            (windowContext || window).document.removeEventListener('keydown', handleArrow);
        };
    }, [elementCount]);
    (0, react_1.useEffect)(() => {
        // Update focused index when element count is changed
        handleElementCountChanged();
    }, [elementCount]);
    return {
        focusedElementIndex: focusedId,
    };
};
exports.default = useArrowKeyListIndex;
